<div class="row" style="margin-top: 2rem; margin-bottom: 2rem">
  <page-alert message="Qrcode Gerado com Sucesso!" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
  <page-alert [message]="paymentErrorMessage" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>
</div>
<div class="pix-payment-container">
  <div class="pix-payment-content">
    <form [formGroup]="customerInfoForm" class="form-card">
      <h2>Informações para gerar cobrança via pix</h2>
      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>Nome</mat-label>
          <input matInput formControlName="name" />
          <mat-error *ngIf="customerInfoForm.get('name')?.hasError('required')">Nome obrigatorio</mat-error>
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>CPF/CNPJ</mat-label>
          <input matInput type="text" inputmode="numeric" formControlName="cpfCnpj" mask="CPF_CNPJ" [dropSpecialCharacters]="true" />
          <mat-error *ngIf="customerInfoForm.get('cpfCnpj')?.hasError('required')">CPF/CNPJ obrigatorio</mat-error>
        </mat-form-field>
        <div class="cpf-warning" *ngIf="shouldShowInvalidDocumentMessage()">{{ getInvalidDocumentMessage() }}</div>
      </div>
      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" />
          <mat-error *ngIf="customerInfoForm.get('email')?.hasError('required')">Email obrigatorio</mat-error>
          <mat-error *ngIf="customerInfoForm.get('email')?.hasError('email')">Email invalido</mat-error>
        </mat-form-field>
      </div>
      <div class="form-group">
        <mat-form-field appearance="outline">
          <mat-label>Telefone</mat-label>
          <input matInput formControlName="phone" />
          <mat-error *ngIf="customerInfoForm.get('phone')?.hasError('required')">Telefone obrigatorio</mat-error>
          <mat-error *ngIf="customerInfoForm.get('phone')?.hasError('pattern')">Informe DDD e telefone</mat-error>
        </mat-form-field>
      </div>
      <div class="button-container">
        <button [disabled]="!canGenerateQrCode()" (click)="createPayment()" mat-flat-button color="primary" cdkFocusInitial>
          {{ submitted ? 'Gerando...' : 'Gerar QR Code' }}
        </button>
      </div>
    </form>
  </div>
</div>
